<template>
	<lazy-background class="hero" :src="(image)?image.thumbs.thumb1920:null">
		<h1>{{ heading }}</h1>
	</lazy-background>
</template>

<script>
	export default {
		props: ['image', 'heading', 'id', 'template']
	}
</script>